export default {
    footers:{
        orgname:'北京盈科千信科技有限公司',
        address:'地址： 北京市海淀区中关村南大街48号',
        email:'邮箱: product@increscence.net'
    },
    login:{
        login:'登录',
        iplogin:'IP 登录',
        userloginservice:'WDL账号登录/注册',
        userlog:'WDL个人账号登录',
        personalaccount:'个人登录',
        accountidorusername:'请输入账号/用户名',
        password:'请输入密码 ',
    },
    enroll:{
        lor:' WDL账号登录/注册',
        user: "请输入用户名 ",
        pass: '请输入密码',
        repass: '请再次输入密码',
        email:'请输入邮箱',
        reemail: '请正确填写邮箱',
        code: '请输入验证码',
        getcode:'获取验证码 ',
        register:'注册',
        reset: '重置'
    },
    // 头部
    header:{
        lookemail:'个人中心',
        Welcome:'欢迎',
        version:'旧版入口',
        colleges:"院校导航",
        login:'登录',
        enroll:'注册',
        out:'退出'
    },
    // 检索字段
    option:{
        schoolname:'学校',
        topic:'主题',
        title:'篇名',
        author:'作者',
        keyword:'关键词',
        chkeyword:"中文关键词",
        source:'来源',
        abstract:'摘要',
        issueDate:'发表时间',
        advisor:'导师/院系',
        language:'语言',
        degree:'学位',
        major:'专业',
        country:'国家',
        and:'与',
        or:'或',
        nor:'非',
        addRule:'增加检索规则',
        delete:'删除检索规则',
        search:'搜索',
        history:'历史记录',
        clearHistory:'清除历史记录',
        basicSearch:'基本检索',
        advancedSearch:'高级检索',
        searchinresults:'二次检索',
        nohistory:'没有最近的历史',
        inputplaceholder:'输入检索词',
        schoolList:'学校列表',
        searchHistory:'检索历史',
        range:'范围',
        relation:'关系',
        content:'内容',
        searchCondition:'检索条件',
        searchResult:'检索结果',
        searchTime:'检索时间',
        oldSwitch:"切换语义检索",
        newSwitch:"切换传统检索",
        remarkSwitch:"你可以输入一句话来深入搜索有关该主题的相关论文",
        enrollInput:"请输入需要查询学位论文的主题、摘要、索引等信息"
    },
    // 首页信息
    home:{
        introduction:'简介',
        searchdescription:'检索说明',
        introductioninfo:"“新学术全球学位论文精选整合服务平台”是高学术质量博硕论文精选平台。该平台收录了全球重点高校学位论文，其中全球排名前100的重点高校覆盖率超过90%，覆盖全球主要国家和地区，涵盖基础科学、医药科学、生命科学、生物技术、工程技术、社科人文等各个学科，是科研与教学必不可少的专业信息检索工具。",
        searchdescriptioninfo1:'1、直接在输入框内输入英文检索词，如 : engine;',
        searchdescriptioninfo2:'2、可以使用 AND 、OR 和 NOR 来处理检索词间的逻辑关系，半角空格分隔默认是 AND;',
        searchdescriptioninfo3:'3、检索是默认对“ 标题 ”检索；妙用:了解选定库中有多少自己关心的内容;',
        searchdescriptioninfo4:'4、可选检索项：标题、作者、学科、学校、关键词、摘要、出版日期、语言和所属国家等;',
        searchdescriptioninfo5:'5、更多更细的检索项组合，请使用 高级搜索。',
        academytitle:'院校分布',
        academyinfo1:'为了保证收录文献的学术质量，“新学术全球学位论文精选整合服务平台”对论文来源院校拥有严格的评审标准。收录全球重点高校学位论文，其中全球排名前100的重点高校覆盖率超过90%。',
        academyinfo2:'论文来源院校分布全球各大洲，覆盖美国、加拿大、英国、德国、比利时、法国、荷兰、日本、韩国、新加坡、印度、瑞典、捷克、瑞士、奥地利、西班牙、澳大利亚、挪威、芬兰、南非、肯尼亚等众多国家。',
        subjectfieldtitle:'学科领域与论文数量',
        subjectfieldinfo:'截至2023年12月，“新学术全球学位论文精选整合服务平台”共计收录学位论文1407000余篇，其中744000余篇来源于全球排名前100院校，具有极高的学术质量与参考价值。',
        subjectfieldinfo1:'各学科学位论文文献量',
        subjectfieldinfo2:'基础与应用自然科学',
        subjectfieldinfo2_n:'500000余篇',
        subjectfieldinfo3:'工程技术',
        subjectfieldinfo3_n:'580000余篇',
        subjectfieldinfo4:'医药与生命科学',
        subjectfieldinfo4_n:'470000余篇',
        subjectfieldinfo5:'社会与管理科学',
        subjectfieldinfo5_n:'670000余篇',
        subjectfieldinfo6:'农业科学',
        subjectfieldinfo6_n:'130000余篇',
        subjectfieldinfo7:'艺术与人文科学',
        subjectfieldinfo7_n:'116000余篇',
        subjectfieldinfo8:'其他学科',
        subjectfieldinfo8_n:'450000余篇',
    },
    // 高级检索说明
    advanceinfo:{
        advanceinfotitle:'高级检索说明：',
        advanceinfo1:'1、每个输入框默认支持英文词组，不支持输入中文检索词;',
        advanceinfo2:'2、可选检索项：标题、作者、学科、学校、关键词、摘要、出版日期、语言和所属国家等;',
        advanceinfo3:'3、高级检索支持多个检索项同时进行检索，各检索项间可设定“ AND 、OR 、 NOR ”的逻辑关系，查准率高。',
    },
    // 检索页信息
    search:{
        schoolname:'学校',
        results:'条结果',
        opengraph:'打开图形摘要',
        closegraph:'关闭图形摘要',
        orderby:'排序方式',
        relevance:'相关性',
        dateNewest:'最近更新',
        dateOldest:'最早更新',
        title:'篇名',
        author:'作者',
        details:'详情',
        abstract:'摘要',
        showMore:'展示更多',
        startYear:'开始年份',
        endYear:'结束年份',
        publishYear:"发布年份",
        degree:'学位',
        language:'语言',
        major:'专业',
        tutor:'导师',
        clear:'清除',
        country:'国家',
        refinemyresults:'检索结果优化',
        filter:'筛选',
        exclude:'排除',
        count:'数量',
        search:'检索院校论文',
        univOverview:'查看院校详情',
        showMore:'显示更多',
        showup:"收起",
        eachPageShows:'每页显示',
        page:'条/页',
        displayMode:'显示方式',
        detail:'详情',
        list:'列表',
        packUp:'收起',
        academy:'院校',
        operation:'操作',
        abstractfanyi:"摘要翻译",
        translation:'译文',
        original:'原文',   
        open:'展示',
        close:'收起',   
        searchswitchct:'切换传统检索',
        searchswitchyy:'切换语义检索',
        searchplaceholder:'检索内容可以是关键词、短语、标题或段落',
        year:'年份',
        zhi:'至',
        years:'年',
        degree:'学位',
        language:'语言',
        Sourceinstitution:'来源院校',
        loadingText:"加载中...",
        noData:'暂无数据'
    },
    // 详情页
    detail:{
        // 详情页--论文详情
        thesisinfo:'论文详情',
        univOverview:'院校概览',
        univRankings:'院校排名',
        subjects:'学位与研究领域',
        within:'在当前院校',
        entire:'全站',
        home:'首页',
        abstract:'摘要',
        affiliations:'论文从属关系',
        keywords:'关键词',
        graphicalAbstract:'图形摘要',
        citethispaper:'引用本文',
        fullText:'全文',
        translate:'翻译',
        translatetitle:'翻译标题',
        offtranslation:'关闭翻译',
        sameAdvisorTheses:'相似文章',
        relatedTheses:'相关文章',
        hotTheses:'热门文章',
        original:'原文',
        translation:'译文',
        chinese:'简体中文',
        thai:'泰语',
        english:'英语',
        german:'德语',
        french:'法语',
        spanish:'西班牙语',
        japanese:'日语',
        portuguese:'葡萄牙语',
        italian:'意大利语',

        // 详情页--院校排名
        globalRank:'全球排名',
        regionalRank:'地区排名',
        countryRank:'国内排名',
        totalStudents:'学生总数',
        universityHighlights:'院校',
        internationalstudents:'留学生总数',
        totalfacultystaff:'师资力量',
        studentgendermix:'学生性别比例',
        pgstudents:'研究生',
        ugstudents:'本科生',
        internationalstaff:'国际教职工',
        domesticstaff:'国内教职工',
        men:'男生数量',
        women:'女生数量',
        iNDICATORRANKINGS:'指数排名',
        similarUniversities:'相关院校',
        chart:'图表',
        data:'数据',
        indicatorShow:'指标说明',

        // 详情页--学位与研究领域
        dEGREELEVELS:'授予学位层次与研究领域',
        undergraduate:'本科',
        postgraduate:'研究生',
        preBachelordegrees:'大学预科学位',
        bachelordegrees:'本科学位',
        masterdegrees:'硕士学位',
        doctoraldegrees:'博士学位',
        artsHumanities:'艺术与人文',
        businessSocialSciences:'商业与社会科学',
        languageCultural:'语言与文化',
        medicineHealth:'医药卫生',
        engineering:'工程学',
        scienceTechnology:'基础科学',

        CreationTime:"创建时间",
        address:"地址",
        url:"网址",
        SubjectRankings:'学科排名',
        subject:'学科',
        ranking:"排名",
        KeyStatistics:"关键数据统计",
        FeaturedDisciplines:'特色学科',
        AllDisciplines:'全部学科',
        region:'地区',
        yy:'引用文本'
    },
    // 底部栏
    footer:{
        info:'访问本站最好使用分辨率不小于1024*768大小的屏幕，支持HTML5的浏览器（如360浏览器,搜狗浏览器等极速模式,Edge浏览器,chrome和firefox 最新版本等）才能得到最佳效果'
    },
    // 学校列表页
    schoollist:{
        sort:'按名称首字母排序',
        backtotop:'回到顶部',
    },
    language:{
        Arabic:"阿拉伯语",
        German:"德语",
        Russian:"俄语",
        French:"法语",
        Korean:"韩语",
        Portuguese:"葡萄牙语",
        Japanese:"日语",
        Thai:"泰语",
        Spanish:"西班牙语",
        English:"英语",
        Italian:"意大利语",
        Vietnamese:"越南语",
        Chinese:"中文(简体)",
        Indonesian:"印度尼西亚语",
        error:'翻译失败',
        close:'取消翻译'
    },
    language_:{
        Arabic:"بالعربية",
        German:"Deutsch",
        Russian:"Русский язык",
        French:"Français",
        Korean:"한국어",
        Portuguese:"Português",
        Japanese:"日本語",
        Thai:"ภาษาไทย",
        Spanish:"Español",
        English:"English",
        Italian:"Italiano",
        Vietnamese:"Tiếng Việt",
        Chinese:"简体中文",
        Indonesian:"Bahasa Indonesia",
        error:'翻译失败',
        close:'取消翻译'
    },
    // 个人中心
    user:{
        PersonalCenter:'个人中心',
        user:'用户',
        email:'邮箱',
        mechanism:'机构',
        Expirationtime:'机构到期时间',
        Searchrecord:'检索记录',
        Transferrecord:'传递记录',
        Searchterm:'检索词',
        condition:'条件',
        request:'请求IP',
        Retrievaltime:'检索时间',
        operation:'操作',
        title:'标题',
        Transferemail:'传递邮箱',
        Transfertime:'传递时间'
    }
}


// WEBPACK FOOTER //
// ./src/assets/lang/zh.js